import {
  Col,
  Row,
  Flex,
  Tabs,
} from "antd";
import AnnouncementsCard from "./components/home/AnnouncementsCard";
import InventoryCard from "./components/home/InventoryCard";
import PendingSubmissionCard from "./components/home/PendingSubmissionCard";
import NewOrderCard from "./components/home/NewOrderCard";
import QrApiUsageCard from "./components/home/QrApiUsageCard";
import UsimPendingSubmissions from "./components/home/UsimPendingSubmissions";
import theme from "../theme";

export default function Home() {
  return (
    <Flex vertical gap={8}>
      <Row style={{ flex: 1 }}>
        <Col span={16}>
          <Flex vertical gap={8} flex={1}>
            <NewOrderCard />
            <div className="custom-badge-tabs" style={{background:"white", marginTop:"12px", borderRadius: "12px"}}> 
              <style>{`
                .custom-badge-tabs .ant-tabs-tab {
                  border-radius: 20px !important;
                  padding: 6px 16px !important;
                  margin: 8px 8px 8px 8px !important;
                  transition: all 0.3s;
                  border: none !important;
                  background: #f0f0f0;
                }
                .custom-badge-tabs .ant-tabs-tab-active {
                  background: rgb(255, 70, 37) !important;
                }
                .custom-badge-tabs .ant-tabs-tab-active .ant-tabs-tab-btn {
                  color: #fff !important;
                }
                .custom-badge-tabs .ant-tabs-ink-bar {
                  display: none !important;
                }
              `}</style>
              <Tabs 
                defaultActiveKey="esim"
                className="custom-badge-tabs"
                tabBarStyle={{
                  backgroundColor: "white",
                  padding: "0 20px",
                  borderRadius: "12px",
                  marginBottom: "12px"
                }}
                items={[
                  {
                    key: 'esim',
                    label: 'Esim',
                    children: <PendingSubmissionCard />,
                  },
                  {
                    key: 'usim',
                    label: 'Usim',
                    children: <UsimPendingSubmissions />,
                  },
                ]}
              />
            </div>
          </Flex>
        </Col>
        <Col span={8}>
          <Flex vertical gap={8} flex={1}>
            <QrApiUsageCard />
            <InventoryCard />
          </Flex>
        </Col>
        <Col span={16}>
          <AnnouncementsCard />
        </Col>
      </Row>
    </Flex>
  );
}
